import {
  Box,
  Grid,
  Paper,
  Skeleton,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tooltip,
} from "@mui/material";
import { Icons, Images } from "assets";
import classNames from "classnames";
import { useEffect, useState } from "react";
import MultiAxisLineChart from "shared/components/lineGraph";
import PaginationComponent from "shared/components/pagination";
import RangeDatePicker from "shared/components/rangeDatePicker";
import useBreadcrumbs from "shared/customHooks/useBreadCrumbs";
import useWindowSize from "shared/customHooks/windowSize";
import { routeConstant } from "shared/routes/routesConstant";

import styles from "./style.module.scss";

const tabs = [
  {
    value: 0,
    label: "Total Books",
  },
  {
    value: 1,
    label: "Free Books",
  },
  {
    value: 2,
    label: "Premium Books",
  },
  {
    value: 3,
    label: "Hard Copies",
  },
];

function AllBooksListings() {
  const screenWidth = useWindowSize();
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(new Date());
  const [tableFilterStartDate, setTableFilterStartDate] = useState<Date | null>(
    null
  );
  const [tableFilterEndDate, settableFilterEndDate] = useState<Date | null>(
    new Date()
  );
  const [activeTab, setActiveTab] = useState<any>(0);
  const [activePage, setActivePage] = useState<number>(1);
  const [loader, setLoader] = useState<boolean>(false);

  useEffect(() => {
    setLoader(true);
    setTimeout(() => {
      setLoader(false);
    }, 2000);
  }, []);

  useBreadcrumbs(
    {
      title: "Books Listings",
      path: routeConstant?.allBooksListings?.path,
    },
    true
  );

  const handleChange = (event: any, newValue: number) => {
    setActiveTab(newValue);
  };

  let dataSetsForGraphs = [
    {
      label: `${tabs?.find((itm) => itm?.value === activeTab)?.label}`,
      data: [
        "8",
        "16",
        "24",
        "32",
        "40",
        "48",
        "56",
        "64",
        "72",
        "400",
        "100",
        "250",
        "800",
        "550",
        "700",
        "850",
        "500",
        "880",
        "920",
        "900",
        "980",
        "800",
        "700",
        "600",
        "500",
        "400",
        "300",
        "280",
      ],
      borderColor: "#1897A6",
      backgroundColor: "#1897A6",
      pointRadius: 5,
      pointHoverRadius: 7,
      pointBorderColor: "rgba(0, 0, 0, 0)",
      pointBackgroundColor: "rgba(0, 0, 0, 0)",
      pointHoverBackgroundColor: "#1897A6",
      pointHoverBorderColor: "#FFFFFF",
    },
  ];

  let books = [
    {
      book_type: 1,
      status: 1,
    },
    {
      book_type: 2,
      status: 2,
    },
    {
      book_type: 1,
      status: 1,
    },
    {
      book_type: 2,
      status: 2,
    },
  ];

  return (
    <div className={styles.mainContainer}>
      <Box className={styles.headingContainer}>
        <div>
          <span className={styles.componentHeading}>
            Total {(8000).toLocaleString()} books in Aliflaila.
          </span>
        </div>
      </Box>

      <div className={styles.componentContainer}>
        <Box className={styles.boxContainer}>
          <Tabs
            value={activeTab}
            onChange={handleChange}
            className={styles.tab}
            variant="scrollable"
            scrollButtons="auto"
            TabIndicatorProps={{
              style: {
                backgroundColor: "black",
              },
            }}
            sx={{ background: "white", padding: "0px 14px" }}
          >
            {tabs?.map((item: any, index: any) => {
              return (
                <Tab
                  label={
                    <div
                      className={classNames(
                        styles.tabs,
                        activeTab === item?.value && styles.active
                      )}
                    >
                      <label className={styles.tabLabel}> {item?.label}</label>
                    </div>
                  }
                  sx={{ padding: "0px" }}
                />
              );
            })}
          </Tabs>

          <div className={styles.separator} />
        </Box>

        <div className={styles.dateContainer}>
          <div>
            <RangeDatePicker
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
            />
          </div>
        </div>

        <div className={styles.graphFilterContainer}></div>
        <div className={styles.graphContainer}>
          <MultiAxisLineChart
            datasets={dataSetsForGraphs}
            legend={false}
            canvasStyle={styles.canvas}
            labels={[
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              "10",
              "11",
              "12",
              "13",
              "14",
              "15",
              "16",
              "17",
              "18",
              "19",
              "20",
              "21",
              "22",
              "23",
              "24",
              "25",
              "26",
              "27",
              "28",
            ]}
          />
        </div>

        <div className={styles.mainContainer}>
          <div className={styles.mainTableContainer}>
            <Box className={styles.topHeadingContainer}>
              <div>
                <div className={styles.heading}>Top Reading Books</div>
                <div className={styles.subHeading}>
                  Books are list by most reads
                </div>
              </div>
              <div className={styles.btnContainer}>
                <button className={styles.filterBtn}>
                  <Icons.FilterIcon /> Filter
                </button>
                <div>
                  <RangeDatePicker
                    startDate={tableFilterStartDate}
                    setStartDate={setTableFilterStartDate}
                    endDate={tableFilterEndDate}
                    setEndDate={settableFilterEndDate}
                    doubleLabel={true}
                  />
                </div>
              </div>
            </Box>

            <TableContainer
              component={Paper}
              sx={screenWidth > 990 ? { width: `${screenWidth - 343}px` } : {}}
              className={styles.tableContainer}
              id="table-view-dashboard"
            >
              <Table>
                <TableHead className={styles.tableHead}>
                  <TableRow>
                    <TableCell>Book Name</TableCell>
                    <TableCell>Publication House</TableCell>
                    <TableCell>Price</TableCell>
                    <TableCell>Read</TableCell>
                    <TableCell>Hard Copy</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className={styles.tableBody}>
                  {loader ? (
                    <Loader />
                  ) : (
                    books?.map((item: any, index: number, arr: any[]) => {
                      return (
                        <TableRow>
                          <TableCell className={styles.biggerCell}>
                            <div
                              style={{
                                display: "flex",
                                gap: "10px",
                                alignItems: "center",
                              }}
                            >
                              <img
                                src={Images.DefaultBookImg}
                                alt="profile_picture"
                                className={styles.bookImg}
                              />
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "2px",
                                }}
                              >
                                <label className={styles.bookName}>
                                  Book Name
                                </label>

                                <label className={styles.authorName}>
                                  by <span>Author Name</span>
                                </label>
                              </div>
                            </div>
                          </TableCell>

                          <TableCell>
                            <label className={styles.publishingHouse}>
                              Publishing House
                            </label>
                          </TableCell>

                          <TableCell className={styles.biggerCell}>
                            <Grid container spacing={1}>
                              <Grid item xs={6}>
                                <label className={styles.darkPurple}>
                                  Buy Price:
                                </label>
                              </Grid>
                              <Grid item xs={6}>
                                <label className={styles.darkPurple}>
                                  00 Coins
                                </label>
                              </Grid>
                              <Grid item xs={6}>
                                <label className={styles.pink}>
                                  Borrow Price:
                                </label>
                              </Grid>
                              <Grid item xs={6}>
                                <label className={styles.pink}>00 Coins</label>
                              </Grid>
                            </Grid>
                          </TableCell>
                          <TableCell>0000 Times</TableCell>
                          <TableCell>Not Available</TableCell>
                          <TableCell>
                            <div className={styles.actionContainer}>
                              <Tooltip arrow title="View">
                                <div>
                                  <Icons.EyeIcon2 />
                                </div>
                              </Tooltip>
                              <Tooltip arrow title="Info">
                                <div>
                                  <Icons.InfoTableIcon />
                                </div>
                              </Tooltip>
                              <Tooltip arrow title="Play Book">
                                <div>
                                  <Icons.PlayCircleIcon />
                                </div>
                              </Tooltip>

                              <Tooltip arrow title="Delete Book">
                                <div>
                                  <Icons.DeleteIcon />
                                </div>
                              </Tooltip>
                            </div>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <PaginationComponent
              totalPages={"1"}
              activePage={activePage}
              setActivePage={setActivePage}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AllBooksListings;

const Loader = () => {
  return (
    <>
      {Array.from({ length: 3 }).map((item, index) => {
        return (
          <TableRow className={styles.loadingRow}>
            <TableCell>
              <div style={{ display: "flex", gap: "4px" }}>
                <Skeleton variant="rounded" width={40} height={40} />
                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <Skeleton variant="rectangular" width={120} height={20} />
                  <Skeleton variant="rectangular" width={120} height={10} />
                </div>
              </div>
            </TableCell>
            <TableCell>
              <Skeleton variant="rounded" width={120} height={10} />
            </TableCell>
            <TableCell>
              <div style={{ display: "flex", gap: "5px" }}>
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    flexDirection: "column",
                  }}
                >
                  <Skeleton variant="rectangular" width={120} height={20} />
                  <Skeleton variant="rectangular" width={120} height={20} />
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    flexDirection: "column",
                  }}
                >
                  <Skeleton variant="rectangular" width={120} height={20} />
                  <Skeleton variant="rectangular" width={120} height={20} />
                </div>
              </div>
            </TableCell>
            <TableCell>
              <Skeleton variant="rounded" width={60} height={10} />
            </TableCell>
            <TableCell>
              <Skeleton variant="rounded" width={60} height={10} />
            </TableCell>

            <TableCell>
              <div className={styles.actionContainer} style={{ gap: "5px" }}>
                <Skeleton variant="circular" width={35} height={35} />
                <Skeleton variant="circular" width={35} height={35} />
                <Skeleton variant="circular" width={35} height={35} />
                <Skeleton variant="circular" width={35} height={35} />
              </div>
            </TableCell>
          </TableRow>
        );
      })}
    </>
  );
};
